import { Injectable } from '@angular/core';
import {
  ProviderBrandsSearchRequestInterface,
  ProviderBrandsSearchResponseInterface,
} from '../../interfaces/blog/provider-brands-search';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { StoreService } from '../../store/store.service';
import { catchError, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProviderBrandsService {
  constructor(private http: HttpClient, private storeService: StoreService) {}

  providerBrands = (request: ProviderBrandsSearchRequestInterface) => {
    return this.http
      .post<ProviderBrandsSearchResponseInterface>(
        `${environment.baseUrl}/providerBrands/search`,
        request
      )
      .pipe(
        catchError(() => {
          return of({
            RedisProviderBrandRoot: null,
            Data: [],
            IsPaging: false,
            Status: 0,
            Page: {
              CurrentPage: 0,
              TotalPage: 0,
              ItemCount: 0,
              TotalItemCount: 0,
            },
            ShowingMessage: 'Sağlayıcı markaları getirilemedi',
            InternalMessage: null,
            Details: {
              QuestStatus: '',
            },
          } as ProviderBrandsSearchResponseInterface);
        })
      );
  };
}
